// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","389":"852dc687","455":"94effba3","488":"a289eb4f","977":"240addac"}[chunkId] + ".chunk.js";
};